"use strict"; // Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _toConsumableArray = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterFromParam = exports.FilterPolyfill = void 0;

var types_1 = require("../types");

var util_1 = require("../util");

var TIMEOUT = 5 * 60 * 1000; // 5 minutes

var JSONRPC_TEMPLATE = {
  jsonrpc: "2.0",
  id: 0
};

var FilterPolyfill = /*#__PURE__*/function () {
  function FilterPolyfill(provider) {
    _classCallCheck(this, FilterPolyfill);

    this.logFilters = new Map(); // <id, filter>

    this.blockFilters = new Set(); // <id>

    this.pendingTransactionFilters = new Set(); // <id, true>

    this.cursors = new Map(); // <id, cursor>

    this.timeouts = new Map(); // <id, setTimeout id>

    this.nextFilterId = (0, types_1.IntNumber)(1);
    this.provider = provider;
  }

  _createClass(FilterPolyfill, [{
    key: "newFilter",
    value: function () {
      var _newFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(param) {
        var filter, id, cursor;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filter = filterFromParam(param);
                id = this.makeFilterId();
                _context.next = 4;
                return this.setInitialCursorPosition(id, filter.fromBlock);

              case 4:
                cursor = _context.sent;
                console.log("Installing new log filter(".concat(id, "):"), filter, "initial cursor position:", cursor);
                this.logFilters.set(id, filter);
                this.setFilterTimeout(id);
                return _context.abrupt("return", (0, util_1.hexStringFromIntNumber)(id));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function newFilter(_x) {
        return _newFilter.apply(this, arguments);
      }

      return newFilter;
    }()
  }, {
    key: "newBlockFilter",
    value: function () {
      var _newBlockFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var id, cursor;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = this.makeFilterId();
                _context2.next = 3;
                return this.setInitialCursorPosition(id, "latest");

              case 3:
                cursor = _context2.sent;
                console.log("Installing new block filter (".concat(id, ") with initial cursor position:"), cursor);
                this.blockFilters.add(id);
                this.setFilterTimeout(id);
                return _context2.abrupt("return", (0, util_1.hexStringFromIntNumber)(id));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function newBlockFilter() {
        return _newBlockFilter.apply(this, arguments);
      }

      return newBlockFilter;
    }()
  }, {
    key: "newPendingTransactionFilter",
    value: function () {
      var _newPendingTransactionFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var id, cursor;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = this.makeFilterId();
                _context3.next = 3;
                return this.setInitialCursorPosition(id, "latest");

              case 3:
                cursor = _context3.sent;
                console.log("Installing new block filter (".concat(id, ") with initial cursor position:"), cursor);
                this.pendingTransactionFilters.add(id);
                this.setFilterTimeout(id);
                return _context3.abrupt("return", (0, util_1.hexStringFromIntNumber)(id));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function newPendingTransactionFilter() {
        return _newPendingTransactionFilter.apply(this, arguments);
      }

      return newPendingTransactionFilter;
    }()
  }, {
    key: "uninstallFilter",
    value: function uninstallFilter(filterId) {
      var id = (0, util_1.intNumberFromHexString)(filterId);
      console.log("Uninstalling filter (".concat(id, ")"));
      this.deleteFilter(id);
      return true;
    }
  }, {
    key: "getFilterChanges",
    value: function getFilterChanges(filterId) {
      var id = (0, util_1.intNumberFromHexString)(filterId);

      if (this.timeouts.has(id)) {
        // extend timeout
        this.setFilterTimeout(id);
      }

      if (this.logFilters.has(id)) {
        return this.getLogFilterChanges(id);
      } else if (this.blockFilters.has(id)) {
        return this.getBlockFilterChanges(id);
      } else if (this.pendingTransactionFilters.has(id)) {
        return this.getPendingTransactionFilterChanges(id);
      }

      return Promise.resolve(filterNotFoundError());
    }
  }, {
    key: "getFilterLogs",
    value: function () {
      var _getFilterLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(filterId) {
        var id, filter;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = (0, util_1.intNumberFromHexString)(filterId);
                filter = this.logFilters.get(id);

                if (filter) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", filterNotFoundError());

              case 4:
                return _context4.abrupt("return", this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
                  method: "eth_getLogs",
                  params: [paramFromFilter(filter)]
                })));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getFilterLogs(_x2) {
        return _getFilterLogs.apply(this, arguments);
      }

      return getFilterLogs;
    }()
  }, {
    key: "makeFilterId",
    value: function makeFilterId() {
      return (0, types_1.IntNumber)(++this.nextFilterId);
    }
  }, {
    key: "sendAsyncPromise",
    value: function sendAsyncPromise(request) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.provider.sendAsync(request, function (err, response) {
          if (err) {
            return reject(err);
          }

          if (Array.isArray(response) || response == null) {
            return reject(new Error("unexpected response received: ".concat(JSON.stringify(response))));
          }

          resolve(response);
        });
      });
    }
  }, {
    key: "deleteFilter",
    value: function deleteFilter(id) {
      console.log("Deleting filter (".concat(id, ")"));
      this.logFilters.delete(id);
      this.blockFilters.delete(id);
      this.pendingTransactionFilters.delete(id);
      this.cursors.delete(id);
      this.timeouts.delete(id);
    }
  }, {
    key: "getLogFilterChanges",
    value: function () {
      var _getLogFilterChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        var filter, cursorPosition, currentBlockHeight, toBlock, response, blocks, highestBlock, newCursorPosition;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                filter = this.logFilters.get(id);
                cursorPosition = this.cursors.get(id);

                if (!(!cursorPosition || !filter)) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", filterNotFoundError());

              case 4:
                _context5.next = 6;
                return this.getCurrentBlockHeight();

              case 6:
                currentBlockHeight = _context5.sent;
                toBlock = filter.toBlock === "latest" ? currentBlockHeight : filter.toBlock;

                if (!(cursorPosition > currentBlockHeight)) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt("return", emptyResult());

              case 10:
                if (!(cursorPosition > filter.toBlock)) {
                  _context5.next = 12;
                  break;
                }

                return _context5.abrupt("return", emptyResult());

              case 12:
                console.log("Fetching logs from ".concat(cursorPosition, " to ").concat(toBlock, " for filter ").concat(id));
                _context5.next = 15;
                return this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
                  method: "eth_getLogs",
                  params: [paramFromFilter(Object.assign(Object.assign({}, filter), {
                    fromBlock: cursorPosition,
                    toBlock: toBlock
                  }))]
                }));

              case 15:
                response = _context5.sent;

                if (Array.isArray(response.result)) {
                  blocks = response.result.map(function (log) {
                    return (0, util_1.intNumberFromHexString)(log.blockNumber || "0x0");
                  });
                  highestBlock = Math.max.apply(Math, _toConsumableArray(blocks));

                  if (highestBlock && highestBlock > cursorPosition) {
                    newCursorPosition = (0, types_1.IntNumber)(highestBlock + 1);
                    console.log("Moving cursor position for filter (".concat(id, ") from ").concat(cursorPosition, " to ").concat(newCursorPosition));
                    this.cursors.set(id, newCursorPosition);
                  }
                }

                return _context5.abrupt("return", response);

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getLogFilterChanges(_x3) {
        return _getLogFilterChanges.apply(this, arguments);
      }

      return getLogFilterChanges;
    }()
  }, {
    key: "getBlockFilterChanges",
    value: function () {
      var _getBlockFilterChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id) {
        var _this2 = this;

        var cursorPosition, currentBlockHeight, blocks, newCursorPosition;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                cursorPosition = this.cursors.get(id);

                if (cursorPosition) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", filterNotFoundError());

              case 3:
                _context6.next = 5;
                return this.getCurrentBlockHeight();

              case 5:
                currentBlockHeight = _context6.sent;

                if (!(cursorPosition > currentBlockHeight)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return", emptyResult());

              case 8:
                console.log("Fetching blocks from ".concat(cursorPosition, " to ").concat(currentBlockHeight, " for filter (").concat(id, ")"));
                _context6.next = 11;
                return Promise.all( // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                (0, util_1.range)(cursorPosition, currentBlockHeight + 1).map(function (i) {
                  return _this2.getBlockHashByNumber((0, types_1.IntNumber)(i));
                }));

              case 11:
                blocks = _context6.sent.filter(function (hash) {
                  return !!hash;
                });
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                newCursorPosition = (0, types_1.IntNumber)(cursorPosition + blocks.length);
                console.log("Moving cursor position for filter (".concat(id, ") from ").concat(cursorPosition, " to ").concat(newCursorPosition));
                this.cursors.set(id, newCursorPosition);
                return _context6.abrupt("return", Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
                  result: blocks
                }));

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getBlockFilterChanges(_x4) {
        return _getBlockFilterChanges.apply(this, arguments);
      }

      return getBlockFilterChanges;
    }()
  }, {
    key: "getPendingTransactionFilterChanges",
    value: function () {
      var _getPendingTransactionFilterChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_id) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", Promise.resolve(emptyResult()));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getPendingTransactionFilterChanges(_x5) {
        return _getPendingTransactionFilterChanges.apply(this, arguments);
      }

      return getPendingTransactionFilterChanges;
    }()
  }, {
    key: "setInitialCursorPosition",
    value: function () {
      var _setInitialCursorPosition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id, startBlock) {
        var currentBlockHeight, initialCursorPosition;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.getCurrentBlockHeight();

              case 2:
                currentBlockHeight = _context8.sent;
                initialCursorPosition = typeof startBlock === "number" && startBlock > currentBlockHeight ? startBlock : currentBlockHeight;
                this.cursors.set(id, initialCursorPosition);
                return _context8.abrupt("return", initialCursorPosition);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setInitialCursorPosition(_x6, _x7) {
        return _setInitialCursorPosition.apply(this, arguments);
      }

      return setInitialCursorPosition;
    }()
  }, {
    key: "setFilterTimeout",
    value: function setFilterTimeout(id) {
      var _this3 = this;

      var existing = this.timeouts.get(id);

      if (existing) {
        window.clearTimeout(existing);
      }

      var timeout = window.setTimeout(function () {
        console.log("Filter (".concat(id, ") timed out"));

        _this3.deleteFilter(id);
      }, TIMEOUT);
      this.timeouts.set(id, timeout);
    }
  }, {
    key: "getCurrentBlockHeight",
    value: function () {
      var _getCurrentBlockHeight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _yield$this$sendAsync, result;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
                  method: "eth_blockNumber",
                  params: []
                }));

              case 2:
                _yield$this$sendAsync = _context9.sent;
                result = _yield$this$sendAsync.result;
                return _context9.abrupt("return", (0, util_1.intNumberFromHexString)((0, util_1.ensureHexString)(result)));

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getCurrentBlockHeight() {
        return _getCurrentBlockHeight.apply(this, arguments);
      }

      return getCurrentBlockHeight;
    }()
  }, {
    key: "getBlockHashByNumber",
    value: function () {
      var _getBlockHashByNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(blockNumber) {
        var response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
                  method: "eth_getBlockByNumber",
                  params: [(0, util_1.hexStringFromIntNumber)(blockNumber), false]
                }));

              case 2:
                response = _context10.sent;

                if (!(response.result && typeof response.result.hash === "string")) {
                  _context10.next = 5;
                  break;
                }

                return _context10.abrupt("return", (0, util_1.ensureHexString)(response.result.hash));

              case 5:
                return _context10.abrupt("return", null);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getBlockHashByNumber(_x8) {
        return _getBlockHashByNumber.apply(this, arguments);
      }

      return getBlockHashByNumber;
    }()
  }]);

  return FilterPolyfill;
}();

exports.FilterPolyfill = FilterPolyfill;

function filterFromParam(param) {
  return {
    fromBlock: intBlockHeightFromHexBlockHeight(param.fromBlock),
    toBlock: intBlockHeightFromHexBlockHeight(param.toBlock),
    addresses: param.address === undefined ? null : Array.isArray(param.address) ? param.address : [param.address],
    topics: param.topics || []
  };
}

exports.filterFromParam = filterFromParam;

function paramFromFilter(filter) {
  var param = {
    fromBlock: hexBlockHeightFromIntBlockHeight(filter.fromBlock),
    toBlock: hexBlockHeightFromIntBlockHeight(filter.toBlock),
    topics: filter.topics
  };

  if (filter.addresses !== null) {
    param.address = filter.addresses;
  }

  return param;
}

function intBlockHeightFromHexBlockHeight(value) {
  if (value === undefined || value === "latest" || value === "pending") {
    return "latest";
  } else if (value === "earliest") {
    return (0, types_1.IntNumber)(0);
  } else if ((0, util_1.isHexString)(value)) {
    return (0, util_1.intNumberFromHexString)(value);
  }

  throw new Error("Invalid block option: ".concat(String(value)));
}

function hexBlockHeightFromIntBlockHeight(value) {
  if (value === "latest") {
    return value;
  }

  return (0, util_1.hexStringFromIntNumber)(value);
}

function filterNotFoundError() {
  return Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
    error: {
      code: -32000,
      message: "filter not found"
    }
  });
}

function emptyResult() {
  return Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
    result: []
  });
}